<template>
  <div id="app">
    <el-container class="app">
      <template v-if="isMobile">
        <el-header v-show="isShowHeader" class="mobile-menu-header-wrap">
          <i class="el-icon-menu" @click="sidePopupChange"></i>
          <div class="logo" @click="backToMobileHome">
            <img src="./assets/img/ACS/ic_logo.png" alt/>
          </div>
          <div class="user-info" v-if="isLogin" @click="toMobileMine">
            <i class="el-icon-user"></i>
            <span class="username">{{ userName }}&nbsp;</span>
          </div>
          <div class="login" v-else @click="toMobileLogin">Login</div>
        </el-header>
        <div class="mobile-scroll-wrap" :style="{ 'min-height': mainHeight + 'px' }">
          <el-backtop target=".mobile-scroll-wrap"></el-backtop>
          <el-main>
            <router-view @changeShow="changeShow" @logout="logout"/>
          </el-main>
        </div>
        <el-footer class="mobile-footer" v-show="isShow">
          <img src="./assets/img/ACS/logo.png" alt/>
          <span>Copyright © 2016 Asian Criminological Society</span>
          <span>Address：Block 2 B402,University Of Macau, Av. Padre Tomas Pereira Taipa, Macau, China </span>
          <span>Phone：(853) 8397 8552</span>
          <span>Fax: (853)8397 8559</span>
          <span>Email：asiancriminologist@gmail.com</span>
        </el-footer>
      </template>
      <template v-else>
        <el-header v-show="isShowHeader" class="menu-header-wrap">
          <div class="logo" @click="backToHome">
            <img src="./assets/img/ACS/ic_logo.png" alt/>
          </div>
          <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                   :router="router" active-text-color="#0B3258">
            <el-menu-item index="/">Home</el-menu-item>
            <el-menu-item index="/news">News</el-menu-item>
            <el-submenu index="1">
              <template slot="title">About us</template>
              <el-menu-item index="/about_us?active=10">Mission</el-menu-item>
              <el-menu-item index="/about_us?active=20">Constitution</el-menu-item>
              <el-menu-item index="/about_us?active=30">Board</el-menu-item>
              <el-menu-item index="/about_us?active=40">Code of Ethics</el-menu-item>
              <el-menu-item index="/about_us?active=50">Awards</el-menu-item>
              <!--            <el-menu-item index="/case?active=2">VIP</el-menu-item>-->
            </el-submenu>
            <el-submenu index="/case">
              <template slot="title">Members</template>
              <el-menu-item index="/case?active=0">Join</el-menu-item>
              <el-menu-item index="/case?active=1">Member Benefits</el-menu-item>
              <!--            <el-menu-item index="/case?active=2">VIP</el-menu-item>-->
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">Conferences</template>
              <el-menu-item index="/conference">Current Meeting</el-menu-item>
              <el-menu-item index="/previousMeeting">Previous Meeting</el-menu-item>
            </el-submenu>
            <el-submenu index="/publications">
              <template slot="title">Publications</template>
              <el-menu-item index="/publications?active=10">Journals</el-menu-item>
              <el-menu-item index="/publications?active=20">Publication of books</el-menu-item>
              <!--            <el-menu-item index="/case?active=2">VIP</el-menu-item>-->
            </el-submenu>
            <el-menu-item index="/contactUs">Contact us</el-menu-item>
            <!--          <el-submenu index="4">-->
            <!--            <template slot="title">Branch</template>-->
            <!--            <el-menu-item>China</el-menu-item>-->
            <!--          </el-submenu>-->
          </el-menu>
          <el-dropdown v-if="isLogin">
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="gotoMine">Profile</el-dropdown-item>
              <el-dropdown-item @click.native="gotoMyRegistrations">My Registrations</el-dropdown-item>
              <el-dropdown-item v-if="isReviewer" @click.native="gotoMyReviews">
                My Reviews
                <el-badge v-if="pendingReviewCount > 0" :value="pendingReviewCount" class="review-badge" />
              </el-dropdown-item>
              <el-dropdown-item @click.native="logout">Logout</el-dropdown-item>
            </el-dropdown-menu>
            <div class="el-dropdown-link userName">
              <i class="el-icon-user"></i>
              <span class="userName-text">{{ userName }}&nbsp;</span>
              <i class="el-icon-arrow-down"></i>
            </div>
          </el-dropdown>
          <div class="login-btn" @click="loginDialog = true" v-else>Login</div>
        </el-header>
        <!-- 非会员提醒横幅 -->
        <div class="membership-banner" v-if="showMembershipBanner && isLogin && !isPayPage && !isAdminPage">
          <div class="banner-content">
            <i class="el-icon-info"></i>
            <span class="banner-text">Become a member to enjoy exclusive benefits including discounted conference registration, journal access, and more.</span>
            <el-button type="primary" size="small" @click="goToMembership" class="banner-btn">Upgrade</el-button>
            <i class="el-icon-close banner-close" @click="closeMembershipBanner"></i>
          </div>
        </div>
        <div class="scroll-wrap" :style="{ 'height': homeHeight + 'px' }">
          <el-backtop target=".scroll-wrap"></el-backtop>
          <el-main :style="{ 'min-height': homeHeight - 180 + 'px' }">
            <router-view @changeShow="changeShow" @logout="logout"/>
          </el-main>
          <el-footer class="footer" v-show="isShow" height="180px">
            <div class="footer-content">
              <img src="./assets/img/ACS/logo.png" alt/>
              <ul class="content-nav">
                <li>
                  <span>Copyright © 2016 Asian Criminological Society</span>
                  <span>Address：Block 2 B402,University Of Macau, Av. Padre Tomas Pereira Taipa, Macau, China </span>
                  <span>Phone：(853) 8397 8552</span>
                  <span>Fax: (853)8397 8559</span>
                  <span>Email：asiancriminologist@gmail.com</span>
                </li>
              </ul>
            </div>
          </el-footer>
        </div>
      </template>
    </el-container>
    <el-dialog :visible.sync="loginDialog" class="login-dialog" width="40%">
      <div class="dialog-body">
        <div class="dialog-title">Login</div>
        <el-form :model="loginForm">
          <el-form-item>
            <el-input v-model="loginForm.email" autocomplete="off" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="loginForm.passWord" autocomplete="off" placeholder="Password" show-password></el-input>
            <div class="forgot-tips" @click="loginDialog = false; recoveryDialog = true">Forgot Your Password?</div>
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <div class="login_btn" @click="login">LOGIN</div>
          <div class="join_btn" @click="loginDialog = false; goToJoin()">JOIN</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="recoveryDialog" class="login-dialog" width="40%">
      <div class="dialog-body">
        <div class="dialog-title">Password Recovery</div>
        <div class="recover-tips">To recover your password please fill in your email address</div>
        <el-form :model="recoveryForm">
          <el-form-item prop="email">
            <el-input v-model="recoveryForm.email" autocomplete="off" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item prop="verificationCode">
            <el-row>
              <el-col span="14">
                <el-input v-model="recoveryForm.verificationCode" id="verificationCode"
                          placeholder="Please enter the verification code" maxlength="4"
                          style="text-align: left; width: 70%"
                          ref="verificationCode"></el-input>
              </el-col>
              <el-col span="6">
                <img id="timebtn" :src="verificationUrl" alt @click="getPicMessage"/>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <div class="login_btn" @click="submit">SUBMIT</div>
          <div class="back_btn" @click="recoveryDialog = false; loginDialog = true">Back To Login</div>
        </div>
      </div>
      <div class="join-wrap">
        <div class="tips-text">Don’t Have An Account Yet？</div>
        <div class="join_btn" @click="loginDialog = false; goToJoin()">JOIN</div>
      </div>
    </el-dialog>
    <!-- 移动端侧边栏导航 -->
    <van-popup v-model="sidePopupVisible" position="left" :style="{ height: '100%' }">
      <van-sidebar v-model="mobilActiveKey" @change="handleMobileChange">
        <van-sidebar-item
            v-for="(item, index) in mobileMenu"
            :key="index"
            :title="item.title"
        />
      </van-sidebar>
    </van-popup>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import colorMixin from '@/mixin/colorMixin'
import {xwjStore} from "@/store/store";
import {getPublicKey, login, getMemberInfo, logout, getverificationUrl, resetPassword} from "@/services/cas-member";
import {encryptRSA, getLogoutSignStr, getSignStrCommon, getHomePath} from "@/common/utils";

export default {
  name: 'app',
  mixins: [colorMixin],
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShowHeader: true,
      isShow: true,
      loginDialog: false,
      recoveryDialog: false,
      loginForm: {},
      recoveryForm: {},
      isLogin: false,
      userName: '',
      publicKey: '',
      uuid: '',
      verificationUrl: '',
      // 非会员提醒横幅
      showMembershipBanner: false,
      // 是否为支付页面（支付页面不显示任何横幅）
      isPayPage: false,
      // 是否为B端管理页面
      isAdminPage: false,
      // 移动端新增
      isMobile: null,
      mainHeight: 0,
      sidePopupVisible: false,
      mobilActiveKey: 0,
      mobileMenu: [
        {title: "Home", path: "mobileHome"},
        {title: "News", path: "newsMobile"},
        {title: "About us", path: "aboutUsMobile"},
        {title: "Members", path: "caseMobile"},
        {title: "Conferences", path: "conferenceMobile"},
        {title: "Publications", path: "publicationsMobile"},
        {title: "Contact us", path: "contactUsMobile"},
        {title: "My Registrations", path: "myRegistrations"},
        {title: "My Reviews", path: "myReviews", reviewerOnly: true}
      ]
    };
  },
  computed: {
    homeHeight() {
      let height = 0
      if (this.isShowHeader) height = window.innerHeight - 60
      else height = window.innerHeight
      return height
    },
    isReviewer() {
      return sessionStorage.getItem('isReviewer') === 'true'
    },
    pendingReviewCount() {
      try {
        const conferences = JSON.parse(sessionStorage.getItem('reviewerConferences') || '[]')
        return conferences.reduce((sum, conf) => sum + (conf.pendingCount || 0), 0)
      } catch (e) {
        return 0
      }
    }
  },
  watch: {
    recoveryDialog(val) {
      if (val) {
        this.getPicMessage()
      }
    },
    $route(to, from) {
      // console.log("to", to)
      if (to.meta.naviPath) {
        this.defaultActive = to.meta.naviPath
      } else {
        this.defaultActive = to.fullPath
      }
      // console.log(this.defaultActive)
      this.isShowHeader = to.meta.showHeader || false
      this.isShow = to.meta.showFooter || false
      this.isMobile = to.meta.isMobile || false
      this.isPayPage = to.name === 'payPage' || to.path === '/payPage'
      this.isAdminPage = to.path.startsWith('/admin')
      if (this.isMobile) {
        setTimeout(() => {
          let headerHeight = this.isShowHeader ? 60 : 0
          let footerHeight = this.isShow ? 229 : 0
          this.mainHeight = window.innerHeight - headerHeight - footerHeight
          this.mobilActiveKey = this.mobileMenu.findIndex(item => item.path == to.name)
        }, 300);
      }
    }
  },
  created() {
    // this.setTheme('#069dbc');
    sessionStorage.setItem('bpublicKey', 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC-T8lcEspX22Lg7nF2o1ANuGZSQqXQYkmvoZm77e8hucs1kljSyHQZ6iPJkY7bGWzelLx1ywd-1EI7w-iCCOfSzENl_ifhQ_0rD5wgDMIF_zJ4gmxGU4BcJRiNFYWZ9W6kWTbiqgbfPNA0Y0MKY-WJlsZv8xybf3FDkkRHKFMJPQIDAQAB')
    sessionStorage.setItem('cpublicKey', 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCfDNFmxWPA5tWkK89y87vzEDuL1CL5J-PrNpyutGfxPfi8Wjjv1lpq9DkmFEZvBh2v0T3LX4VB8kEr418GUf-JQYh-gLc8Dd_Cmpi7BjZr9r942Dq0_zPVae3IvERewapeXFadxkGs4UqxMfgttp6Ry3vpXm6aGXdg-qxEKgx-vQIDAQAB')
  },
  mounted() {
    this.setTheme('#069dbc');
    this.changeThemeStyle();
    window.addEventListener("setItem", this.checkLogin);
    this.checkLogin();
    xwjStore.set("getLogin", () => {
      this.loginDialog = true
    });
    xwjStore.set("logout", () => {
      this.logout()
    });
    this.getPublicKey()
  },
  methods: {
    ...mapMutations(['setTheme']),
    ...mapActions(['changeThemeStyle']),
    // 移动端新增start
    backToMobileHome() {
      this.$router.push("/mobileHome");
    },
    sidePopupChange() {
      this.sidePopupVisible = !this.sidePopupVisible
    },
    handleMobileChange() {
      this.sidePopupVisible = false
      if (this.mobileMenu[this.mobilActiveKey]) {
        let name = this.mobileMenu[this.mobilActiveKey].path
        if (name == "aboutUsMobile") name += "?active=10"
        if (name == "conferenceMobile") name += "?active=10"
        if (name == "publicationsMobile") name += "?active=10"
        this.$router.push(`/${name}`)
      }
    },
    toMobileLogin() {
      this.$router.push("loginMobile");
    },
    toMobileMine() {
      this.$router.push("mineMobile");
    },
    // end
    backToHome() {
      this.$router.push({name: "home"});
    },
    getPublicKey() {
      getPublicKey().then((res) => {
        if (res.data) {
          sessionStorage.setItem('cpublicKey', res.data.publicKey)
          this.publicKey = res.data.publicKey
        }
      })
    },
    getPicMessage() {
      this.uuid = this.$uuidv4()
      getverificationUrl({captchaId: this.uuid}).then((res) => {
        var blob = new Blob([res], {type: "image/jpeg"});
        var url = window.URL.createObjectURL(blob);
        this.verificationUrl = url
      })
      // this.verificationUrl = getverificationUrl() + "?captchaId=" + this.uuid;
    },
    goToJoin() {
      this.$router.push({name: "case", query: {active: 0}});
    },
    gotoMine() {
      this.$router.push({name: "members"});
    },
    gotoMyRegistrations() {
      this.$router.push("/my-registrations");
    },
    gotoMyReviews() {
      this.$router.push("/my-reviews");
    },
    changeShow() {
      this.isShowHeader = this.$route.meta.showHeader
      this.isShow = this.$route.meta.showFooter
    },
    handleSelect(key) {
      // this.isShowHeader = true
      // this.isShow = this.defaultActive != key;
      // window.console.log(this.isShow);
    },
    checkLogin() {
      let isNull = sessionStorage.getItem('token') == null
      this.isLogin = !isNull
      if (this.isLogin) {
        if (JSON.parse(sessionStorage.getItem('memberInfo'))) {
          this.userName = JSON.parse(sessionStorage.getItem('memberInfo')).memberFirstName
        } else {
          this.userName = ''
        }
        // 检查是否是非会员，如果是则显示横幅（B端管理页面不显示）
        const memberInfo = JSON.parse(sessionStorage.getItem('memberInfo') || '{}')
        const isAdminPage = this.$route.path.startsWith('/admin')
        if (!isAdminPage && !memberInfo.isMember && !memberInfo.judgeIsMember) {
          this.showMembershipBanner = true
        }
      }
    },
    login() {
      let data = {}
      console.log(this.publicKey)
      let rsaPassword = ''
      rsaPassword = encryptRSA(this.loginForm.passWord, this.publicKey)
      const userInfo = `${this.loginForm.email},${rsaPassword}`
      const nonceStr = Math.random().toString().replace('0.', '')
      const timestamp = Date.parse(new Date())
      const loginType = 'password'
      let obj = {loginType, nonceStr, timestamp, userInfo};
      const loginSign = getSignStrCommon(obj)
      data.loginType = loginType
      data.nonceStr = nonceStr
      data.sign = loginSign
      data.timestamp = timestamp
      data.userInfo = userInfo
      login(data).then((res) => {
        if (res.resultCode == '0') {
          sessionStorage.setItem('token', res.data.token)
          sessionStorage.setItem('refreshToken', res.data.refreshToken)
          // Store reviewer information
          if (res.data.isReviewer !== undefined) {
            sessionStorage.setItem('isReviewer', res.data.isReviewer)
          }
          if (res.data.reviewerConferences) {
            sessionStorage.setItem('reviewerConferences', JSON.stringify(res.data.reviewerConferences))
          }
          this.$message.success('Login Success')
          this.loginDialog = false
          getMemberInfo().then((res) => {
            if (res.resultCode == '0') {
              sessionStorage.setItem('memberInfo', JSON.stringify(res.data))
              this.checkLogin()
              // 检查是否非会员，显示提醒横幅（B端管理页面不显示）
              const isAdminPage = this.$route.path.startsWith('/admin')
              if (!isAdminPage && !res.data.isMember && !res.data.judgeIsMember) {
                this.showMembershipBanner = true
              }
              // 检查是否有保存的redirect路径
              const redirectPath = sessionStorage.getItem('loginRedirectPath')
              if (redirectPath) {
                sessionStorage.removeItem('loginRedirectPath')
                this.$router.push(redirectPath)
              } else {
                // 检查是否有待处理的会议报名
                const pendingConferenceId = sessionStorage.getItem('pendingConferenceId')
                if (pendingConferenceId) {
                  sessionStorage.removeItem('pendingConferenceId')
                  this.$router.push({
                    path: '/conference-registration',
                    query: { conferenceId: pendingConferenceId }
                  })
                } else {
                  location.reload()
                }
              }
            }
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            customClass: 'customClass'
          });
        }
      })
    },
    logout() {
      const nonceStr = Math.random().toString().replace('0.', '')
      const timestamp = Date.parse(new Date());
      let refreshToken = sessionStorage.getItem('refreshToken')
      let obj = {nonceStr, refreshToken, timestamp};
      const logoutSign = getSignStrCommon(obj)
      const data = {
        refreshToken: refreshToken,
        timestamp: timestamp,
        nonceStr: nonceStr,
        sign: logoutSign
      }
      logout(data)
      sessionStorage.clear();
      window.location.href = getHomePath()
      window.location.reload()
    },
    submit() {
      let data = {}
      const nonceStr = Math.random().toString().replace('0.', '')
      const timestamp = Date.parse(new Date())
      const retrievePasswordEmailInfo = `${this.recoveryForm.email},${this.uuid},${this.recoveryForm.verificationCode}`
      let obj = {nonceStr, retrievePasswordEmailInfo, timestamp};
      const sign = getSignStrCommon(obj)
      data.nonceStr = nonceStr
      data.sign = sign
      data.timestamp = timestamp
      data.retrievePasswordEmailInfo = retrievePasswordEmailInfo
      resetPassword(data).then((res) => {
        this.$message.success('Send Success')
        this.recoveryDialog = false
      })
    },

    // 跳转到会员页面
    goToMembership() {
      this.$router.push({name: 'members', query: {activeTab: '2'}})
    },

    // 关闭会员提醒横幅
    closeMembershipBanner() {
      this.showMembershipBanner = false
    }
  }
};
</script>

<style lang="scss">
@import "common.css";
@import "mobile.scss";

* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.mobile-menu-header-wrap {
  .user-info {
    display: flex;
    align-items: center;

    .username {
      font-size: 16px;
      color: #333;
    }
  }
}


.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin: 0 auto;
  align-items: center;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    cursor: pointer;

    img {
      width: 100%;
      line-height: 60px;
    }
  }

  .login-btn {
    background: #0B3258;
    border: 1px solid #0B3258;
    border-radius: 6px;
    height: 32px;
    width: 74px;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }

  .login-btn:hover {
    background: #072038;
  }
}

.scroll-wrap {
  overflow: scroll;
}

.el-main {
  padding: 0 !important;
  overflow: hidden !important;
}

.footer {
  width: 100%;
  height: 280px;
  overflow: hidden;
  background-color: #0B3258;
  display: flex;

  &-content {
    width: 80%;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .content-nav {
      display: flex;
      justify-content: space-around;

      li {
        display: flex;
        flex-direction: column;
        padding: 0 10px;
        //justify-content: center;
        align-items: flex-start;

        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }

        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 4px 0;
          font-size: 14px;
        }
      }
    }

    img {
      width: 70px;
      height: 70px;
      padding: 10px;
    }
  }

  .copyright {
    height: 30px;
    background: #125688;

    span {
      color: #fff;
      line-height: 30px;
    }
  }
}

.login-dialog {
  .el-dialog__body {
    padding: 0;
  }

  .dialog-body {
    padding: 10%;

    .dialog-title {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 24px;
    }

    .forgot-tips {
      text-align: end;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.25);
      cursor: pointer;
    }

    .recover-tips {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.25);
      margin-bottom: 24px;
    }

    .dialog-footer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .login_btn {
        width: 150px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #0B3258;
        border-radius: 6px;
        font-size: 14px;
        color: #FFFFFF;
        cursor: pointer;
      }

      .join_btn {
        width: 150px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #FFFFFF;
        border: 1px solid #0B3258;
        border-radius: 6px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        cursor: pointer;
      }

      .back_btn {
        width: 150px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #FFFFFF;
        font-size: 14px;
        color: #0B3258;
        cursor: pointer;
      }
    }
  }

  .join-wrap {
    background: #FAFAFA;
    height: 54px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .join_btn {
      width: 92px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      background: #FFFFFF;
      border: 1px solid #0B3258;
      border-radius: 6px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      cursor: pointer;
    }

    .tips-text {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      margin-right: 34px;
    }
  }
}

.menu-item-class {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #0B3258;
  line-height: 22px;
}

.verifi-wrap {
  display: flex;
  flex-direction: row;
}

  .userName {
    width: 100px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    color: #0B3258;

    .userName-text {
      text-align: end;
      max-width: 90px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .review-badge {
    margin-left: 8px;
    
    ::v-deep .el-badge__content {
      transform: translateY(-50%) translateX(100%);
    }
  }

.menu-header-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}

.el-menu-demo {
  width: 1000px;
  display: inline-block;
  flex-shrink: 1;
}

// 响应式：屏幕宽度不足时调整
@media screen and (max-width: 1280px) {
  .menu-header-wrap {
    justify-content: space-between;
  }
  
  .el-menu-demo {
    width: auto;
    flex: 1;
    min-width: 0;
  }
  
  .el-dropdown-link.userName {
    width: auto;
    min-width: 80px;
    flex-shrink: 0;
    margin-left: 10px;
  }
  
  .userName-text {
    max-width: 60px;
  }
}

@media screen and (max-width: 992px) {
  .el-menu-demo .el-menu-item,
  .el-menu-demo .el-submenu {
    padding: 0 10px;
  }
  
  .userName-text {
    max-width: 50px;
  }
}

@media screen and (max-width: 768px) {
  .el-dropdown-link.userName {
    min-width: 60px;
  }
  
  .userName-text {
    max-width: 40px;
    font-size: 12px;
  }
}

.customClass {
  z-index: 20010 !important;
}


body {
  font-family: 'Source', 'Source Han Sans Heav', sans-serif;
}

// ============================================================
// 富文本内容区统一样式 — 覆盖 reset.scss 的全局清零
// 优先级：内联 style > 本样式 > reset.scss，管理员自定义样式永远生效
// ============================================================
.wang-editor-html,
.wang-editor-htmlv,
.wang-editor-html2,
.wang-editor-htmlv2 {
  line-height: 1.8;
  word-break: break-word;
  color: #333;

  // ---- 标题 ----
  h1 { font-size: 2em;   font-weight: bold; margin: 0.67em 0; }
  h2 { font-size: 1.5em; font-weight: bold; margin: 0.75em 0; }
  h3 { font-size: 1.17em;font-weight: bold; margin: 0.83em 0; }
  h4 { font-size: 1em;   font-weight: bold; margin: 1em 0; }
  h5 { font-size: 0.83em;font-weight: bold; margin: 1.25em 0; }
  h6 { font-size: 0.67em;font-weight: bold; margin: 1.5em 0; }

  // ---- 段落 ----
  p {
    margin: 0 0 1em 0;
    line-height: 1.8;
    &:last-child { margin-bottom: 0; }
  }

  // ---- 换行间距 ----
  br + br { display: none; } // 连续空行合并

  // ---- 图片 ----
  img {
    max-width: 100%;
    height: auto;
    margin: 0.5em 0;
  }

  // ---- 链接 ----
  a {
    color: #1890ff;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }

  // ---- 水平线 ----
  hr {
    border: none;
    border-top: 1px solid #e8e8e8;
    margin: 1.5em 0;
  }

  // ---- 引用块 ----
  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    background-color: #f1f1f1;
  }

  // ---- 行内代码 ----
  code {
    display: inline-block;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
    font-family: Consolas, Monaco, 'Courier New', monospace;
    font-size: 0.9em;
  }

  // ---- 代码块 ----
  pre {
    background-color: #f5f5f5;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 12px;
    margin: 1em 0;
    overflow-x: auto;
    line-height: 1.6;

    code {
      display: block;
      background: none;
      border-radius: 0;
      padding: 0;
      margin: 0;
    }
  }

  // ---- 列表 ----
  ul, ol {
    margin: 0.5em 0 0.5em 2em;
    padding: 0;
  }
  ul { list-style: disc; }
  ul ul { list-style: circle; }
  ul ul ul { list-style: square; }
  ol { list-style: decimal; }

  li {
    margin-bottom: 0.3em;
    line-height: 1.8;
  }

  // ---- 表格 ----
  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-collapse: collapse;
    margin: 1em 0;
    width: 100%;
  }
  table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 8px 12px;
    line-height: 1.6;
  }
  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
    background-color: #fafafa;
    font-weight: bold;
  }

  // ---- 粗体/斜体 ----
  strong, b { font-weight: bold; }
  em, i { font-style: italic; }

  // ---- 上下标 ----
  sup { vertical-align: super; font-size: 0.75em; }
  sub { vertical-align: sub;   font-size: 0.75em; }

  // ---- 图文容器 ----
  figure {
    margin: 1em 0;
    text-align: center;
    img { margin: 0; }
  }
  figcaption {
    font-size: 0.9em;
    color: #999;
    margin-top: 0.5em;
  }
}

// 会员提醒横幅样式
.membership-banner {
  background: #e6f7ff;
  border-bottom: 1px solid #91d5ff;
  padding: 6px 20px;
  position: relative;
  z-index: 100;

  .banner-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    i.el-icon-info {
      color: #1890ff;
      font-size: 14px;
      flex-shrink: 0;
    }

    .banner-text {
      color: #595959;
      font-size: 13px;
      flex: 1;
      text-align: left;
      line-height: 1.4;
    }

    .banner-btn {
      background: #1890ff;
      border-color: #1890ff;
      color: #fff;
      font-weight: 500;
      font-size: 12px;
      padding: 4px 12px;
      white-space: nowrap;
      flex-shrink: 0;
      line-height: 1.5;
      height: auto;
      min-height: 0;

      &:hover {
        background: #40a9ff;
        border-color: #40a9ff;
      }
    }

    .banner-close {
      color: #8c8c8c;
      font-size: 14px;
      cursor: pointer;
      padding: 2px;
      opacity: 0.8;
      transition: all 0.3s;
      flex-shrink: 0;

      &:hover {
        opacity: 1;
        color: #595959;
      }
    }
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .membership-banner {
    padding: 5px 12px;

    .banner-content {
      gap: 6px;

      .banner-text {
        font-size: 11px;
        line-height: 1.3;
      }

      .banner-btn {
        font-size: 11px;
        padding: 4px 8px;
      }
    }
  }
}
</style>
